export default "__VITE_ASSET__f598c41c__"